<div class="form-input select"
     [ngClass]="{
    'predefined-value': predefinedStyleEnabled,
    'form-input--fulfilled': isInputFulfilled,
    'select--has-value': select.hasValue,
    'select--focused': isFocused
}">

    <div class="ng-select-container"
         [ngClass]="{'ng-select-container--custom-icon': hasCustomIcon}"
    >
        <!-- <div class="ng-select-placeholder" [class.animation]="animation">
            {{ (placeholder? placeholder: '')| translate }}
        </div> -->
        <ng-select #select
                   [items]="fieldConfig.select.async ? (items | async) : fieldConfig.options.items "
                   [loading]="loading"
                   [multiple]="(fieldConfig.type === fieldType.MultiSelectAndChips) || (fieldConfig.type === fieldType.MultiSelect)"
                   [formControl]="control"
                   [clearable]="clearable"
                   [closeOnSelect]="closeOnSelect"
                   [selectableGroup]="true"
                   [searchable]="searchable"
                   [loadingText]="loadingText | translate"
                   [dropdownPosition]="dropdownPosition"
                   [notFoundText]="notFoundText | translate"
                   [placeholder]="(placeholder? placeholder: '')| translate"
                   [bindValue]="fieldConfig.options.item ? fieldConfig.options.item: null"
                   [labelForId]="id"
                   [id]="fieldConfig.fieldKey + 'Select'"
                   [ngClass]="{'ng-select--hidden-dropdown': isMobile, 'ng-select--animation-enabled': animationEnabled}"

                   (focus)="onFocus()"
                   (focusout)="focusOut()"
                   (open)="openSelectEvent()"
                   (change)="onSelectChange()"
                   (close)="closeSelectEvent()"
                   (search)="searchSelectEvent($event)"
                   (click)="onClick($event)"
        >
            <ng-template *ngIf="selectSearchVisible" ng-header-tmp>
                <mat-form-field>
                    <input type="text"
                           matInput
                           [placeholder]="selectSearchText | translate"
                           (input)="select.filter($event.target.value)">
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
            </ng-template>

            <ng-container [ngSwitch]="fieldConfig.options.template">
                <ng-container *ngSwitchCase="templateOptions.eurotax">
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                        <app-vehicle-version [item]="item" [paddingTop]="true"></app-vehicle-version>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item" let-index="index">
                        <div *ngIf="showLoadingLabel" class="ng-value-label text-grey">{{ loadingText | translate }}
                        </div>
                        <app-vehicle-version *ngIf="!showLoadingLabel"
                                             [ngClass]="{'visibility-hidden': hideLabel && searchable}" [item]="item"
                                             [paddingBottom]="true"></app-vehicle-version>
                    </ng-template>
                </ng-container>
                <ng-container *ngSwitchCase="templateOptions.infoexpert">
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                        <app-vehicle-version [item]="item" [paddingTop]="true"></app-vehicle-version>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item" let-index="index">
                        <div *ngIf="showLoadingLabel" class="ng-value-label text-grey">{{ loadingText | translate }}
                        </div>
                        <app-vehicle-version *ngIf="!showLoadingLabel"
                                             [ngClass]="{'visibility-hidden': hideLabel && searchable}" [item]="item"
                                             [paddingBottom]="true"></app-vehicle-version>
                    </ng-template>
                </ng-container>
                <ng-container *ngSwitchCase="templateOptions.model">
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                        <app-vehicle-model-list-item [item]="item"></app-vehicle-model-list-item>
                    </ng-template>
                    <ng-template ng-label-tmp let-item="item" let-index="index">
                        <div *ngIf="showLoadingLabel" class="ng-value-label text-grey">{{ loadingText | translate }}
                        </div>
                        <app-vehicle-model-list-item *ngIf="!showLoadingLabel"
                                                     [ngClass]="{'visibility-hidden': hideLabel && searchable}"
                                                     [item]="item">
                        </app-vehicle-model-list-item>
                    </ng-template>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <ng-template *ngIf="multiple; else customOption" ng-option-tmp let-item="item" let-item$="item$"
                                 let-index="index">
                        <mat-checkbox style="text-transform: capitalize" id="item-{{index}}" [ngModel]="item$.selected">
                            {{item[fieldConfig.options.label.label]}}
                        </mat-checkbox>
                    </ng-template>

                    <ng-template #customOption ng-option-tmp let-item="item" let-index="index">
                        <div *ngIf="!translateLabel"> {{getConcatLabel(item, fieldConfig.options.label)}}</div>
                        <div *ngIf="translateLabel"> {{getConcatLabel(item, fieldConfig.options.label) | translate}}
                        </div>
                    </ng-template>

                    <ng-template ng-label-tmp let-item="item" let-index="index">
                        <div *ngIf="showValueLabel && !translateLabel" class="ng-value-label"
                             [ngClass]="{'display-none': hideLabel && searchable}"> {{ getConcatLabel(item,
                            fieldConfig.options.label)}}
                        </div>
                        <div *ngIf="showValueLabel && translateLabel" class="ng-value-label"
                             [ngClass]="{'display-none': hideLabel && searchable}"> {{getConcatLabel(item,
                            fieldConfig.options.label) | translate}}
                        </div>
                        <div *ngIf="showLoadingLabel" class="ng-value-label text-grey">{{ loadingText | translate }}
                        </div>
                    </ng-template>
                </ng-container>
            </ng-container>


            <ng-template *ngIf="fieldConfig.select.submitButton" ng-footer-tmp>
                <div class="select-with-button">
                    <button class="btn btn--small" (click)="submitValues()">{{ 'SELECT_COMPONENT.save' | translate }}
                    </button>
                </div>
            </ng-template>

            <ng-template ng-footer-tmp *ngIf="selectSearchVisible">
                <div class="select__footer" (click)="closeSelect()">
                    {{ 'SELECT_DIALOG_COMPONENT.close' | translate}}
                </div>
            </ng-template>


        </ng-select>

        <span *ngIf="typeToSearchTextVisible"
              class="ng-select-container__type-to-search-text">
            {{ typeToSearchText | translate }}
        </span>

        <span *ngIf="customIconVisible" class="material-icons ng-select__custom-icon">{{ customIcon }}</span>

        <mat-error *ngIf="errorsMap.get(fieldConfig.fieldKey)">
            {{ (context + '.' + fieldConfig.fieldKey + '.' + errorsMap.get(fieldConfig.fieldKey))|translate }}
        </mat-error>
        <mat-hint *ngIf="verificationHintVisible"
                  class="select__mat-hint">
            {{'HINTS.verificationRequired' | translate}}
        </mat-hint>
        <div class="ng-select-counter" [ngClass]="{'ng-select-counter-up' : searchable}">{{contentText() | translate}}
        </div>

    </div>

    <div class="desc-icon">
        <app-tooltip-icon *ngIf="tooltipIconVisible"
                          [outlined]="tooltipOutlined"
                          [description]="fieldConfig.description">
        </app-tooltip-icon>
        <app-information-icon class="information-icon" *ngIf="informationIconVisible"
                              [information]="this.fieldConfig.predefined.additionalInfo | additionalInfo"
                              [description]="fieldConfig.description | translate">
        </app-information-icon>
    </div>

</div>
